"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var ItemHolder_1 = __importDefault(require("../common/ItemHolder"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var NavigationMenu_styles_1 = require("./NavigationMenu.styles");

var NavigationMenuItem_1 = __importDefault(require("./NavigationMenuItem"));

var NavigationMenu =
/** @class */
function (_super) {
  __extends(NavigationMenu, _super);
  /* istanbul ignore next */


  function NavigationMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      activeItem: _this.props.activeItem
    };

    _this.onItemClick = function (index) {
      return function (e) {
        _this.setState({
          activeItem: index
        });

        _super.prototype.onItemClick.call(_this, index)(e);
      };
    };

    return _this;
  }

  Object.defineProperty(NavigationMenu.prototype, "className", {
    get: function get() {
      var _a;

      var _b = this.props,
          classes = _b.classes,
          fluid = _b.fluid;
      return classnames_1.default(classes.navigationMenu, (_a = {}, _a[classes.fluid] = fluid, _a));
    },
    enumerable: false,
    configurable: true
  });

  NavigationMenu.prototype.render = function () {
    var _a = this.props,
        header = _a.header,
        footer = _a.footer,
        classes = _a.classes;
    return react_1.default.createElement("div", {
      className: this.className,
      "data-test-id": "navigation-menu"
    }, react_1.default.createElement("div", {
      className: classes.header,
      "data-test-id": "navigation-menu-header"
    }, header), react_1.default.createElement("div", {
      className: classes.body,
      "data-test-id": "navigation-menu-body"
    }, this.getItems(this.activeItem(), NavigationMenuItem_1.default)), react_1.default.createElement("div", {
      className: classes.footer,
      "data-test-id": "navigation-menu-footer"
    }, footer));
  };

  NavigationMenu = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(NavigationMenu_styles_1.styles)
  /* istanbul ignore next */
  ], NavigationMenu);
  return NavigationMenu;
}(ItemHolder_1.default);

exports.default = NavigationMenu;